import { Component } from '@angular/core';

@Component({
    selector: 'tr-wrapper-right-column',
    template: `<div class="tr-wrapper-column--right">
        <ng-content></ng-content>
    </div>`,
})
export class TrWrapperRightColumnComponent {}
